var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1411_6531",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1411_6531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2908 8.17885C21.0659 8.10474 20.916 8.10474 20.7661 8.10474C20.841 8.10474 20.6911 8.10474 20.7661 8.10474H15.2186V3.95454C15.2186 2.99111 14.469 2.25 13.4944 2.25H11.2455C10.9456 2.25 10.7957 2.32411 10.5708 2.39822C10.2709 2.47233 10.046 2.69466 9.82114 2.917L5.92295 7.88241H3.2242C2.24965 7.95652 1.5 8.69763 1.5 9.66107V19.2955C1.5 20.2589 2.24965 21 3.2242 21H17.6925C18.0673 21 18.4421 20.8518 18.742 20.6294C19.0419 20.4071 19.1918 20.1107 19.2668 19.8142L22.4153 10.3281C22.7152 9.36462 22.1904 8.40119 21.2908 8.17885ZM4.57357 17.665V11.2915H5.92295V17.665H4.57357ZM9.07149 17.665V9.51285L11.8452 5.95553V9.80929C11.8452 10.7727 12.5949 11.5138 13.5694 11.5138H18.4421L16.4181 17.665H9.07149Z",
    fill: "#65AA20"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUp);
export default __webpack_public_path__ + "static/media/thumb-up.c6c573161fcc24fed2f180e0b82a37d6.svg";
export { ForwardRef as ReactComponent };